import * as i0 from '@angular/core';
import * as i1 from './in-memory-web-api.module';
export const InMemoryWebApiModuleNgFactory:i0.NgModuleFactory<i1.InMemoryWebApiModule> = (null as any);
var _decl0_0:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_1:i0.ElementRef<any> = (<any>(null as any));
